import { SET_EDITOR_SIZE } from 'admin/constants/actions';

/**
 * @param size {Object}
 * @param size.width {Number|undefined}
 * @param size.height {Number|undefined}
 * @param size.min {Number|undefined}
 * @param size.max {Number|undefined}
 * @return {{type: *, payload: *}}
 */
export function setEditorSize(size: { width?: number; height?: number; min?: number; max?: number }) {
	return {
		type: SET_EDITOR_SIZE,
		payload: size,
	};
}
